import { isMonitorAgentLogsEnabled } from '../isMonitorAgentLogsEnabled';

import featureFlagConstants from '~/common/helpers/featureFlagConstants';
import useFeatureFlag from '~/common/hooks/useFeatureFlag';

export function useAgentLogsEnabled() {
  const { MONITOR_AGENT_LOGS } = featureFlagConstants;

  const { treatments, isReady } = useFeatureFlag([MONITOR_AGENT_LOGS]);

  const isEnabled = isMonitorAgentLogsEnabled(
    treatments[MONITOR_AGENT_LOGS]?.treatment
  );

  return { isEnabled, isReady };
}
